import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import PhoneNumberFormat from "sr/helpers/functions/PhoneNumberFormat";
import EmailLink from "sr/helpers/ui-components/EmailLink";
import { getFile } from "sr/utils/api/getFile";
import { getFiles } from "sr/utils/api/getFiles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapMarker,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";

export const CandidateProfile = ({
  reference = null,
  candidate,
  training,
  medical,
  employment,
}) => {
  const navigate = useNavigate();
  const address_line_1 =
    candidate?.job_id?.job_advanced_id?.reporting_address?.address_line_1;
  const address_line_2 =
    candidate?.job_id?.job_advanced_id?.reporting_address?.address_line_2;
  const reportingCity =
    candidate?.job_id?.job_advanced_id?.reporting_address?.city;
  const candidateAddressLine1 = candidate?.cleaner_id?.address?.address_line_1;
  const candidateAddressLine2 = candidate?.address?.address_line_2;
  const candidateCity = candidate?.address?.city;
  const [profileImg, setProfileImg] = useState<any>();

  const fetchProfileImg = async (cleanerId) => {
    const params = {
      cleaner_id: cleanerId,
    };
    const profileImg = await getFiles(params);
    if (profileImg?.success === true) {
      const filterfile = profileImg?.data?.filter(
        (item) => item?.file?.fieldname === "profile_img"
      );
      if (filterfile && filterfile[0]?.file?.key) {
        const fileimg = await getFile(filterfile[0]?.file?.key);
        if (fileimg) {
          // const rawImageData = new Uint8Array(fileimg as ArrayBuffer);
          // const blob = new Blob([rawImageData], { type: 'image/png' });
          const newImageUrl = URL.createObjectURL(fileimg);
          setProfileImg(newImageUrl);
          return true;
        }
      }
    }
  };

  useEffect(() => {
    fetchProfileImg(candidate?.cleaner_id?.id);
  }, [candidate?.cleaner_id?.id]);

  return (
    <>
      <div className="mb-5 flex flex-col gap-4 md:flex-row md:items-start md:space-x-5 md:gap-0">
        <div className="h-40 w-40 flex-shrink-0">
          <div className="">
            <img
              alt="Profile"
              className="rounded w-40 h-40 object-cover"
              src={`${
                profileImg
                  ? profileImg
                  : "/media/icons/displayProfilePlaceholder.png"
              } `}
            />
          </div>
        </div>
        <div className="flex-1 min-w-0 py-3">
          <div className="border-b-2 border-gray-300 py-2 flex justify-between items-center flex-wrap gap-3">
            <h1 className="text-3xl  text-[#595959]">
              {candidate?.cleaner_id?.first_name}{" "}
              {candidate?.cleaner_id?.last_name}
            </h1>
            {candidate?.job_id?.id && candidate?.cleaner_id?.id && (
              <button
                onClick={() => navigate(`/messages?jobId=${candidate?.job_id?.id}&cleanerId=${candidate?.cleaner_id?.id}`)}
                className="bg-[#0078ae] text-white px-4 py-2 rounded-lg font-semibold hover:bg-[#00608c] transition-colors flex items-center space-x-2"
              >
                <FontAwesomeIcon icon={faEnvelope} />
                <span>Message Candidate</span>
              </button>
            )}
          </div>
          <div className="pt-3 space-y-2.5">
            <div className="flex min-w-0 items-start space-x-2 text-sm leading-6">
              <FontAwesomeIcon
                className="mt-1 text-[#0078ae]"
                icon={faEnvelope}
              />
              <div className="min-w-0 break-all text-sm font-semibold leading-6 text-[#0078ae] [&_a]:!text-[#0078ae] [&_a:hover]:!text-[#0078ae]">
                <EmailLink
                  email={candidate?.cleaner_id?.email}
                  subject="Hello"
                  body="Hi, how are you?"
                />
              </div>
            </div>
            <div className="flex min-w-0 items-start space-x-2 text-sm leading-6">
              <FontAwesomeIcon className="mt-1 text-[#0078ae]" icon={faPhone} />
              <div className="min-w-0 text-sm font-semibold leading-6 text-[#0078ae]">
                {candidate?.cleaner_id?.mobile_number ? (
                  <a
                    className="hover:text-[#0078ae]"
                    href={`tel:${candidate?.cleaner_id?.mobile_number}`}
                  >
                    {PhoneNumberFormat(candidate?.cleaner_id?.mobile_number)}
                  </a>
                ) : (
                  <span className="font-normal text-[#595959]">
                    Not provided
                  </span>
                )}
              </div>
            </div>
            <div className="flex min-w-0 items-start space-x-2 text-sm leading-6 text-[#595959]">
              <FontAwesomeIcon
                className="mt-1 text-[#0078ae]"
                icon={faMapMarker}
              />
              <p className="min-w-0">
                {candidateAddressLine1 ||
                candidateAddressLine2 ||
                candidateCity ? (
                  <>
                    {candidateAddressLine1} {candidateAddressLine2}{" "}
                    {candidateCity}
                  </>
                ) : (
                  <span className="font-normal">Not provided</span>
                )}
              </p>
            </div>
          </div>
          <div className="mt-5 border-t border-neutral-200 pt-3">
            <p className="text-sm leading-6 text-[#717b9e]">
              Applied to {candidate?.job_id?.job_title}
              {address_line_1 || address_line_2 || reportingCity ? ` - ` : ""}
              {address_line_1} {address_line_2} {reportingCity}
            </p>
          </div>
        </div>
      </div>
      <div>
        <h1 className="text-xl  pb-2">Training</h1>
        {training != "" ? (
          training?.map((item, index) => (
            <div key={index} className="pb-4 mb-4 border-b border-neutral-200">
              <div className="">
                <span className="font-bold">Title: </span>
                <span className="text-base  text-black">{item?.training}</span>
              </div>
              <div>
                <span className="font-bold">Date Attended: </span>
                <span className="text-base">
                  {DateFormat(item?.date_attended)}
                </span>
              </div>
              <div>
                <span className="font-bold">Description: </span>
                <span>{item?.description}</span>
              </div>
            </div>
          ))
        ) : (
          <p className="pb-4 mb-4 border-b border-neutral-200">
            <FormattedMessage
              id="No {title} Data Added."
              defaultMessage="No {title} Data Added."
              values={{ title: "Training" }}
            ></FormattedMessage>
          </p>
        )}
        <div>
          {/* <h1 className="text-xl  pb-2">Medical Condition</h1>
          {medical != "" ? (
            medical?.map((item, index) => (
              <div
                key={index}
                className="pb-4 mb-4 border-b border-neutral-200"
              >
                <div>
                  <span className="font-bold">Condition: </span>
                  <span className="text-base  text-black">
                    {item?.condition}
                  </span>
                </div>
                <div>
                  <span className="font-bold">Since When: </span>
                  <span className="text-base">
                    {DateFormat(item?.since_when)}{" "}
                  </span>
                </div>
                <div>
                  <span className="font-bold">Description: </span>
                  <span>{item?.description}</span>
                </div>
              </div>
            ))
          ) : (
            <p className="pb-4 mb-4 border-b border-neutral-200">
              <FormattedMessage
                id="No {title} Data Added."
                defaultMessage="No {title} Data Added."
                values={{ title: "Medical Condition" }}
              ></FormattedMessage>
            </p>
          )} */}
          <div>
            <h1 className="text-xl  pb-2">Employment</h1>
            {employment != "" ? (
              employment?.map((item, index) => (
                <div key={index} className="pb-4 mb-4">
                  <div>
                    <span className="font-bold">Job Title: </span>
                    <span className="text-base  text-black">
                      {item?.job_title}{" "}
                    </span>
                  </div>
                  <div>
                    <span className="font-bold">Company Name: </span>
                    <span className="text-base">{item?.company_name}</span>
                  </div>
                  <div>
                    <div>
                      <span className="font-bold">Company Location: </span>
                      <span className="text-base">
                        {item?.company_location}
                      </span>
                    </div>
                  </div>
                  <div>
                    <span className="font-bold">Working Since: </span>
                    <span className="text-base">
                      {item?.currently_employed
                        ? DateFormat(item?.working_since_start)
                        : DateFormat(item?.working_since_start) +
                          "-" +
                          DateFormat(item?.working_since_end)}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <p className="pb-4 mb-4 border-b border-neutral-200">
                <FormattedMessage
                  id="No {title} Data Added."
                  defaultMessage="No {title} Data Added."
                  values={{ title: "Employment" }}
                ></FormattedMessage>
              </p>
            )}
          </div>
          <div>
            <h1 className="text-xl  pb-2">Reference</h1>
            {reference != "" ? (
              reference?.map((item, index) => (
                <div key={index} className="pb-4 mb-4">
                  <div>
                    <span className="font-bold">First Name: </span>
                    <span className="text-base  text-black">
                      {item?.first_name}{" "}
                    </span>
                  </div>
                  <div>
                    <span className="font-bold">Last Name: </span>
                    <span className="text-base">{item?.last_name}</span>
                  </div>
                  <div>
                    <div>
                      <span className="font-bold">Email: </span>
                      <span className="text-base">{item?.email}</span>
                    </div>
                  </div>
                  <div>
                    <span className="font-bold">Mobile Number: </span>
                    <span className="text-base">{item?.mobile_number}</span>
                  </div>
                </div>
              ))
            ) : (
              <p className="pb-4 mb-4 border-b border-neutral-200">
                <FormattedMessage
                  id="No {title} Data Added."
                  defaultMessage="No {title} Data Added."
                  values={{ title: "Reference" }}
                ></FormattedMessage>
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
